export const WEB_PERMISSIONS = Object.freeze({
  DASHBOARD_HOME_VIEW: "dashboard:home:view",
  DATA_TABLE_VIEW: "data:table:view",
  DATA_CHART_VIEW: "data:chart:view",
  DATA_AVG_VIEW: "data:avg:view",
  DATA_CHECK_VALUE_ERROR_VIEW: "data:check-value-error:view",
  DATA_PIE_CHART_VIEW: "data:pie-chart:view",
  DATA_CATONE_VIEW: "data:catone:view",
  DATA_STATISTICS_VIEW: "data:statistics:view",
  DATA_STATISTICS_EXPORT: "data:statistics:export",
  ARCHIVE_DETAIL_VIEW: "archive:detail:view",
  ARCHIVE_HISTORY_VIEW: "archive:history:view",
  ARCHIVE_RECORD_VIEW: "archive:record:view",
  ARCHIVE_RECORD_MANAGE: "archive:record:manage",
  ALGORITHM_ESTRUS_VIEW: "algorithm:estrus:view",
  ALGORITHM_ESTRUS_MANAGE: "algorithm:estrus:manage",
  ALGORITHM_DISEASE_VIEW: "algorithm:disease:view",
  ALGORITHM_DISEASE_MANAGE: "algorithm:disease:manage",
  ALGORITHM_CALVING_VIEW: "algorithm:calving:view",
  ALGORITHM_CALVING_MANAGE: "algorithm:calving:manage",
  DEVICE_ALGORITHM_PARAM_VIEW: "device:algorithm-param:view",
  DEVICE_ALGORITHM_PARAM_EDIT: "device:algorithm-param:edit",
  DEVICE_INFO_VIEW: "device:info:view",
  DEVICE_INFO_EDIT: "device:info:edit",
  DEVICE_INFO_EXPORT: "device:info:export",
  DEVICE_ACTIVITY_VIEW: "device:activity:view",
  DEVICE_ACTIVITY_EDIT: "device:activity:edit",
  DEVICE_TIME_INTERVAL_VIEW: "device:time-interval:view",
  DEVICE_TIME_INTERVAL_EDIT: "device:time-interval:edit",
  DEVICE_TIME_CALIBRATION_VIEW: "device:time-calibration:view",
  DEVICE_TIME_CALIBRATION_EXECUTE: "device:time-calibration:execute",
  DEVICE_PACKET_LOSS_VIEW: "device:packet-loss:view",
  DEVICE_PACKET_LOSS_EXPORT: "device:packet-loss:export",
  QUALITY_FACTORY_DEVICE_VIEW: "quality:factory-device:view",
  QUALITY_OPERATION_LOG_VIEW: "quality:operation-log:view",
  QUALITY_DEVICE_VIEW: "quality:device:view",
  QUALITY_DEVICE_EDIT: "quality:device:edit",
  QUALITY_FACTORY_DEVICE_EXPORT: "quality:factory-device:export",
  QUALITY_OPERATION_LOG_EXPORT: "quality:operation-log:export",
  TOOL_CONVERT_VIEW: "tool:convert:view",
  TOOL_CONVERT_EXECUTE: "tool:convert:execute",
  TOOL_BATCH_VIEW: "tool:batch:view",
  TOOL_BATCH_EXECUTE: "tool:batch:execute",
  DEVICE_SCAN_VIEW: "device:scan:view",
  DEVICE_SCAN_EXECUTE: "device:scan:execute",
  MONITOR_OVERVIEW_VIEW: "monitor:overview:view",
  MONITOR_OBSERVATION_VIEW: "monitor:observation:view",
  MONITOR_DEVICE_VIEW: "monitor:device:view",
  MONITOR_PACKET_LOSS_VIEW: "monitor:packet-loss:view",
  MONITOR_ALGORITHM_TASK_VIEW: "monitor:algorithm-task:view",
  MONITOR_ALGORITHM_TASK_RETRY: "monitor:algorithm-task:retry",
  MONITOR_TABLE_GROWTH_DATA_VIEW: "monitor:table-growth-data:view",
  MONITOR_TABLE_GROWTH_CONFIG_VIEW: "monitor:table-growth-config:view",
  MONITOR_TABLE_GROWTH_HISTORY_VIEW: "monitor:table-growth-history:view",
  MONITOR_TABLE_GROWTH_VIEW: "monitor:table-growth:view",
  MONITOR_TABLE_GROWTH_DATA_MANAGE: "monitor:table-growth-data:manage",
  MONITOR_TABLE_GROWTH_CONFIG_MANAGE: "monitor:table-growth-config:manage",
  SETTINGS_MAIL_CONFIG_VIEW: "settings:mail-config:view",
  SETTINGS_MAIL_HISTORY_VIEW: "settings:mail-history:view",
  SETTINGS_MAIL_VIEW: "settings:mail:view",
  SETTINGS_MAIL_MANAGE: "settings:mail:manage",
  CLIENT_PUSH_MQTT_VIEW: "client-push:mqtt:view",
  CLIENT_PUSH_MQTT_MANAGE: "client-push:mqtt:manage",
  CLIENT_PUSH_CONFIG_PAGE_VIEW: "client-push:config-page:view",
  CLIENT_PUSH_HISTORY_VIEW: "client-push:history:view",
  CLIENT_PUSH_CONFIG_VIEW: "client-push:config:view",
  CLIENT_PUSH_CONFIG_MANAGE: "client-push:config:manage",
  CLIENT_PUSH_HISTORY_RETRY: "client-push:history:retry",
  ACCESS_USER_VIEW: "access:user:view",
  ACCESS_USER_MANAGE: "access:user:manage",
  ACCESS_ROLE_VIEW: "access:role:view",
  ACCESS_ROLE_MANAGE: "access:role:manage",
  ACCESS_AUDIT_VIEW: "access:audit:view",
  MILK_PARLOR_TOPOLOGY_VIEW: "milk-parlor:topology:view",
  MILK_PARLOR_TOPOLOGY_MANAGE: "milk-parlor:topology:manage",
  MILK_PARLOR_PRESENCE_IDENTIFICATION_VIEW: "milk-parlor:presence-identification:view",
  MILK_PARLOR_PRESENCE_IDENTIFICATION_MANAGE: "milk-parlor:presence-identification:manage",
  MILK_PARLOR_OUTBOX_VIEW: "milk-parlor:outbox:view",
  MILK_PARLOR_OUTBOX_RETRY: "milk-parlor:outbox:retry",
  MILK_PARLOR_RAW_COMMAND_VIEW: "milk-parlor:raw-command:view",
});
